function getUtcStringFromOffset(utcOffset) {
    var plus = utcOffset >= 0 ? '+' : '';
    var hour = Math.floor(utcOffset / 60);
    var min = Math.abs(utcOffset % 60).toString();
    var padMin = min.length > 1 ? min : "0" + min;
    return "" + plus + hour + ":" + padMin;
}
export default getUtcStringFromOffset;



//////////////////
// WEBPACK FOOTER
// ./src/imports/getUtcStringFromOffset.ts
// module id = 244
// module chunks = 0